import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=33f21696&scoped=true&"
import script from "./AddCandidate.vue?vue&type=script&lang=js&"
export * from "./AddCandidate.vue?vue&type=script&lang=js&"
import style0 from "./AddCandidate.vue?vue&type=style&index=0&id=33f21696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f21696",
  null
  
)

export default component.exports